import { render, staticRenderFns } from "./pipStoryDetail.vue?vue&type=template&id=63abb4b2&"
import script from "./pipStoryDetail.vue?vue&type=script&lang=js&"
export * from "./pipStoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./pipStoryDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports